import { Expose, Transform } from 'class-transformer';
import { DrupalIdentifier, DrupalNode } from '@nx-icilalune/drupal-types';
import { UIDate } from './ui.model';

export class Blog extends DrupalNode {
  public static readonly type = 'blogs';

  @Transform(({ obj }) => {
    return obj?.attributes?.summary;
  })
  @Expose()
  override summary!: string;

  @Transform(({ obj }) => {
    if (obj?.attributes?.date_only) {
      const date: UIDate = {
        value: obj?.attributes?.date_only,
        format: 'date-formats.medium',
      };
      return date;
    }
    return undefined;
  })
  @Expose()
  date!: UIDate | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.paragraphs?.data || undefined;
  })
  @Expose()
  paragraphs: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.media?.data || undefined;
  })
  @Expose()
  media!: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.associated_projects?.data || undefined;
  })
  @Expose()
  associated!: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.authors?.data || undefined;
  })
  @Expose()
  authors!: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.attributes?.list_item_text_preview || undefined;
  })
  @Expose()
  textPreview!: string | undefined;
}
